import { Button } from "@mui/material";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import CustomToolTip from "../../../../components/CustomTooltip";
import { Toast } from "../../../../components/Toast";

const MigrateDataButton = () => {
  const colors = useColors();
  const { migrateData } = useAPI();

  const handleOnClick = () => {
    migrateData()
      .then(() => {
        Toast.success("Sent request to migrate data");
      })
      .catch(() => {
        Toast.error("Error migrating data");
      });
  };

  return (
    <>
      <CustomToolTip title="Send request to migrate data">
        <Button
          variant="outlined"
          sx={{
            backgroundColor: colors.gray_main,
            "&:hover": {
              backgroundColor: colors.grey_light,
            },
          }}
          onClick={handleOnClick}
        >
          Migrate Data
        </Button>
      </CustomToolTip>
    </>
  );
};

export default MigrateDataButton;
